import { Copy, Facebook, Instagram, Mail, MapPin, Phone, Info } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/site";

const copy = async (text, label) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${label} vágólapra másolva`);
  } catch {
    toast.error("A másolás nem sikerült");
  }
};

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        testId="contact-header"
        motif="flower"
        eyebrow="Kapcsolat"
        title={<>Lépj velünk <span className="italic text-[#C04B58]">kapcsolatba.</span></>}
        description="Időpontkérés, konzultáció, kérdés — válassz bármelyik csatornát, személyesen válaszolunk."
      />

      <section className="mx-auto max-w-7xl px-5 pb-28 sm:px-8">
        <Reveal>
          <div className="mb-10 flex items-start gap-4 rounded-2xl border border-[#43262C]/50 bg-[#9A3542]/8 p-6" data-testid="booking-note">
            <Info size={20} className="mt-0.5 shrink-0 text-[#C04B58]" />
            <p className="text-sm leading-relaxed text-zinc-300">
              Az időpontkérés és egyeztetés manuálisan, Instagramon, Facebookon, e-mailben vagy telefonon történik.
              Tetoválás időpontfoglalás előtt a kiválasztott művésszel konzultálunk.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="card-dark h-full p-8 sm:p-10">
              <p className="eyebrow">Elérhetőségek</p>
              <ul className="mt-8 space-y-7">
                <li className="flex items-start gap-4">
                  <span className="rounded-full border border-white/10 p-3 text-[#9A3542]"><MapPin size={18} /></span>
                  <div className="flex-1">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">Cím</p>
                    <p className="mt-1 text-white" data-testid="contact-address">{CONTACT.address}</p>
                    <button onClick={() => copy(CONTACT.address, "Cím")} data-testid="contact-copy-address" className="mt-2 flex items-center gap-1.5 text-[11px] text-zinc-500 transition-colors hover:text-[#C04B58]">
                      <Copy size={12} /> Másolás
                    </button>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <span className="rounded-full border border-white/10 p-3 text-[#9A3542]"><Phone size={18} /></span>
                  <div className="flex-1">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">Telefon</p>
                    <a href={CONTACT.phoneHref} data-testid="contact-phone" className="mt-1 block text-white transition-colors hover:text-[#C04B58]">
                      {CONTACT.phone}
                    </a>
                    <button onClick={() => copy(CONTACT.phone, "Telefonszám")} data-testid="contact-copy-phone" className="mt-2 flex items-center gap-1.5 text-[11px] text-zinc-500 transition-colors hover:text-[#C04B58]">
                      <Copy size={12} /> Másolás
                    </button>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <span className="rounded-full border border-white/10 p-3 text-[#9A3542]"><Mail size={18} /></span>
                  <div className="flex-1">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-500">E-mail</p>
                    <a href={`mailto:${CONTACT.email}`} data-testid="contact-email" className="mt-1 block text-white transition-colors hover:text-[#C04B58]">
                      {CONTACT.email}
                    </a>
                    <button onClick={() => copy(CONTACT.email, "E-mail cím")} data-testid="contact-copy-email" className="mt-2 flex items-center gap-1.5 text-[11px] text-zinc-500 transition-colors hover:text-[#C04B58]">
                      <Copy size={12} /> Másolás
                    </button>
                  </div>
                </li>
              </ul>

              <div className="mt-10 flex flex-wrap gap-3">
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram-btn" className="btn-primary">
                  <Instagram size={16} /> {CONTACT.instagramHandle}
                </a>
                <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="contact-facebook-btn" className="btn-ghost">
                  <Facebook size={16} /> Facebook
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="card-dark h-full overflow-hidden" data-testid="contact-map-card">
              <iframe
                title="Shuten Tattoo Studio térkép — Podmaniczky utca 75"
                data-testid="contact-map"
                src={CONTACT.mapsEmbed}
                className="h-full min-h-[480px] w-full grayscale invert-[0.92] contrast-[0.9]"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
